var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatFilled(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 1.66406H6.66602C3.33268 1.66406 1.66602 3.33073 1.66602 6.66406V17.4974C1.66602 17.9557 2.04102 18.3307 2.49935 18.3307H13.3327C16.666 18.3307 18.3327 16.6641 18.3327 13.3307V6.66406C18.3327 3.33073 16.666 1.66406 13.3327 1.66406ZM11.666 12.7057H5.83268C5.49102 12.7057 5.20768 12.4224 5.20768 12.0807C5.20768 11.7391 5.49102 11.4557 5.83268 11.4557H11.666C12.0077 11.4557 12.291 11.7391 12.291 12.0807C12.291 12.4224 12.0077 12.7057 11.666 12.7057ZM14.166 8.53906H5.83268C5.49102 8.53906 5.20768 8.25573 5.20768 7.91406C5.20768 7.5724 5.49102 7.28906 5.83268 7.28906H14.166C14.5077 7.28906 14.791 7.5724 14.791 7.91406C14.791 8.25573 14.5077 8.53906 14.166 8.53906Z",
    fill: "url(#paint0_linear_14366_117990)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14366_117990",
    x1: -4.88559,
    y1: 17.9032,
    x2: 18.8167,
    y2: -3.21026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03BE6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFilled);
export default __webpack_public_path__ + "static/media/chat-filled.5039209499e03f59424fc34c4aa7ab49.svg";
export { ForwardRef as ReactComponent };